module.exports = __webpack_public_path__ + "assets/img/3062.9a923a48.png";